import './style.scss';

interface Props {
  src: string;
  alt?: string;
}

export const LoadingLogo = ({ src, alt = 'Loading' }: Props) => {
  return (
    <div className="dec-loading-logo" role="status" aria-live="polite">
      <img className="dec-loading-logo__image" src={src} alt={alt} />
    </div>
  );
};
